import { Injectable } from '@angular/core';
import { WebSocketSubject } from 'rxjs/webSocket';
import {environment} from '../../../environments/environment';
import { Router } from '@angular/router';
import { Constants } from '../../shared/constants';

@Injectable({
  providedIn: 'root'
})
export class WebSocketService {

  public socket: WebSocketSubject<any>;
  private readonly wsocApiEndpoint: string;

  constructor(private router: Router) {
    this.wsocApiEndpoint = environment.api.endpoints[1].endpoint;
  }

  public connect() {
    this.socket = new WebSocketSubject({
      url: this.wsocApiEndpoint,
      openObserver: {
        next: value => {
          console.log('Connected: ' + JSON.stringify(value));
          this.socket.next({ 'action': 'signin' });
          this.heartbeat();
        }
      }
    });
    return this.socket.asObservable();
  }

  public send = (message) => {
    console.log('Payload: ', JSON.stringify(message));
    this.socket.next(message);
  }

  private heartbeat() {
    setInterval(() => {
      console.log('Heartbeat : ping');
      this.socket.next({ 'action': 'ping' });
    }, Constants.POLL_INTERVAL);
  }

}
